export default __webpack_public_path__ + "img/1f729466ba7b3615ab854f9f6fc783c0.svg";